import { ContainerSlotDto } from '@operations/app/api'
import { useOperationsStore } from '@operations/AppProvider'
import IconDangerous from '@operations/assets/icons/handlingInstructions/IconDangerous'
import IconEmpty from '@operations/assets/icons/handlingInstructions/IconEmpty'
import IconFull from '@operations/assets/icons/handlingInstructions/IconFull'
import IconHolds from '@operations/assets/icons/handlingInstructions/IconHolds'
import IconOutOfGaugeFront from '@operations/assets/icons/handlingInstructions/IconOutOfGaugeFront'
import IconOutOfGaugeFrontRear from '@operations/assets/icons/handlingInstructions/IconOutOfGaugeFrontRear'
import IconOutOfGaugeRear from '@operations/assets/icons/handlingInstructions/IconOutOfGaugeRear'
import IconReefer from '@operations/assets/icons/handlingInstructions/IconReefer'
import IconRestowSvg from '@operations/assets/icons/handlingInstructions/IconRestowSvg'
import {
  amountMultipleContainers,
  hasActiveHolds,
  hasFrontOutOfGauge,
  hasFrontRearOutOfGauge,
  hasMultipleContainers,
  hasRearOutOfGauge,
  isDangerous,
  isEmpty,
  isFull,
  isReefer,
  isRestow,
} from '@operations/features/craneOperator/utils'
import { useTranslate } from '@tolgee/react'
import { ButtonOption, CopyIcon, MultipleIcon, OptionsButton } from '@tom-ui/ui'
import { useMemo } from 'react'

interface Props {
  size: number
  slotContainer?: ContainerSlotDto | null
}
export const SlotIcons = ({ size, slotContainer }: Props) => {
  const { t } = useTranslate()
  const { appStore } = useOperationsStore()

  const options: ButtonOption[] = useMemo(() => {
    if (!hasMultipleContainers(slotContainer)) return []

    return slotContainer!.multipleStowageContainerNumbers!.map(number => ({
      label: number,
      rightIcon: <CopyIcon fontSize='small' />,
      onClick: () => {
        navigator.clipboard.writeText(number)
        appStore.setShowAlert(
          'info',
          t('containerNumberCopiedToClipboard', '"{number}" copied to clipboard', { number }),
        )
      },
    }))
  }, [slotContainer])

  return (
    <>
      {isEmpty(slotContainer) && <IconEmpty size={size} />}
      {isFull(slotContainer) && <IconFull size={size} />}
      {isRestow(slotContainer) && <IconRestowSvg size={size} />}
      {isReefer(slotContainer) && <IconReefer size={size} />}
      {isDangerous(slotContainer) && <IconDangerous size={size} />}

      {(hasFrontRearOutOfGauge(slotContainer) && <IconOutOfGaugeFrontRear size={size} />) ||
        (hasFrontOutOfGauge(slotContainer) && <IconOutOfGaugeFront size={size} />) ||
        (hasRearOutOfGauge(slotContainer) && <IconOutOfGaugeRear size={size} />)}

      {hasActiveHolds(slotContainer) && <IconHolds size={size} />}

      {hasMultipleContainers(slotContainer) && (
        <OptionsButton
          noPadding
          size='small'
          position='right'
          tooltip={t('seeContainers', 'See containers')}
          options={options}
          customIcon={<MultipleIcon amount={amountMultipleContainers(slotContainer)} size={size} />}
        />
      )}
    </>
  )
}
